export function pushToDataLayer(eventObject) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(eventObject)
}
